module.exports = __webpack_public_path__ + "static/img/faPath4.d227c405.gif";